import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter } from '../../../adapter/Adapter.mjs';
import {
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
  get_NullableIntAdapter1poaa869odci7 as get_NullableIntAdapter,
  get_NullableBooleanAdapter3vvq2rksy333a as get_NullableBooleanAdapter,
  nullable1in0t8o94jx9t as nullable,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { Companion_getInstancehtoztkmjh1bx as Companion_getInstance } from '../GraphQLFloat.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePartyInput3ikp23en56cie as SavePartyInput } from '../SavePartyInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePartyInput_InputAdapterClass;
function SavePartyInput_InputAdapter() {
  if (SavePartyInput_InputAdapterClass === VOID) {
    class $ {
      g40(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      p6w(writer, customScalarAdapters, value) {
        writer.c4d('partyId');
        get_partyIdAdapter().h40(writer, customScalarAdapters, value.r6u_1);
        var tmp = value.s6u_1;
        if (tmp instanceof Present()) {
          writer.c4d('name');
          present(get_NullableStringAdapter()).f41(writer, customScalarAdapters, value.s6u_1);
        }
        var tmp_0 = value.t6u_1;
        if (tmp_0 instanceof Present()) {
          writer.c4d('email');
          present(get_NullableStringAdapter()).f41(writer, customScalarAdapters, value.t6u_1);
        }
        var tmp_1 = value.u6u_1;
        if (tmp_1 instanceof Present()) {
          writer.c4d('pairingRule');
          present(get_NullableIntAdapter()).f41(writer, customScalarAdapters, value.u6u_1);
        }
        var tmp_2 = value.v6u_1;
        if (tmp_2 instanceof Present()) {
          writer.c4d('badgesEnabled');
          present(get_NullableBooleanAdapter()).f41(writer, customScalarAdapters, value.v6u_1);
        }
        var tmp_3 = value.w6u_1;
        if (tmp_3 instanceof Present()) {
          writer.c4d('defaultBadgeName');
          present(get_NullableStringAdapter()).f41(writer, customScalarAdapters, value.w6u_1);
        }
        var tmp_4 = value.x6u_1;
        if (tmp_4 instanceof Present()) {
          writer.c4d('alternateBadgeName');
          present(get_NullableStringAdapter()).f41(writer, customScalarAdapters, value.x6u_1);
        }
        var tmp_5 = value.y6u_1;
        if (tmp_5 instanceof Present()) {
          writer.c4d('callSignsEnabled');
          present(get_NullableBooleanAdapter()).f41(writer, customScalarAdapters, value.y6u_1);
        }
        var tmp_6 = value.z6u_1;
        if (tmp_6 instanceof Present()) {
          writer.c4d('animationsEnabled');
          present(get_NullableBooleanAdapter()).f41(writer, customScalarAdapters, value.z6u_1);
        }
        var tmp_7 = value.a6v_1;
        if (tmp_7 instanceof Present()) {
          writer.c4d('animationSpeed');
          present(nullable(customScalarAdapters.e48(Companion_getInstance().l6p_1))).f41(writer, customScalarAdapters, value.a6v_1);
        }
      }
      h40(writer, customScalarAdapters, value) {
        return this.p6w(writer, customScalarAdapters, value instanceof SavePartyInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePartyInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePartyInput_InputAdapterClass = $;
  }
  return SavePartyInput_InputAdapterClass;
}
var SavePartyInput_InputAdapter_instance;
function SavePartyInput_InputAdapter_getInstance() {
  return SavePartyInput_InputAdapter_instance;
}
//region block: init
SavePartyInput_InputAdapter_instance = new (SavePartyInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePartyInput_InputAdapter_instance as SavePartyInput_InputAdapter_instance2d93hz34kf5lo,
};
//endregion

//# sourceMappingURL=SavePartyInput_InputAdapter.mjs.map
